import { PieChart, PieSeries } from "@amcharts/amcharts4/charts";
import { color, create, percent } from "@amcharts/amcharts4/core";
import _ from "lodash";
import React, { Component } from "react";
import WebFont from "webfontloader";
import "../../../assets/styles/component/legend.scss";
import { CCS_ANALYSIS_COLORS, CYAN, MOST_POPULAR_ENTRY_POINTS_COLORS, WHITE } from "../../../constants";
import { disposeChart } from "../helpers/chartHelpers";
import { legendConfiguration } from "../helpers/configurations";
import { ThemeInt } from "../helpers/types";

interface Props {
  data: Array<Record<string, number | string>>;
  theme: ThemeInt;
  chartId: string;
  valueField: string;
  categoryField: string;
}

class JourneyExcellenceDonutChart extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  chart!: PieChart;
  chartId = this.props.chartId;

  componentDidMount() {
    WebFont.load({
      custom: {
        families: ["nissan"],
        urls: ["../../../assets/fonts/fonts.css"],
      },
      // @ts-ignore
      active: this.initChart(),
      timeout: 8000,
    });
  }

  componentDidUpdate(prevProps: any) {
    //Handle refreshing the chart when the dataset changes
    if (!_.isEqual(prevProps, this.props)) {
      disposeChart(this.chartId).then((res) => {
        this.initChart();
      });
    }
  }

  componentWillUnmount() {
    disposeChart(this.chartId);
  }

  initChart() {
    const { data, theme, valueField, categoryField } = this.props;
    this.chart = create(this.chartId, PieChart);
    this.chart.data = data.map((item: any) => ({ ...item, color: MOST_POPULAR_ENTRY_POINTS_COLORS[item[categoryField]] }));
    this.chart.numberFormatter.numberFormat = "#.";
    // this.chart.radius = 110;

    this.chart.layout = "vertical";
    this.chart.innerRadius = percent(35);

    // Legend configuration
    this.chart.legend = legendConfiguration(theme);
    this.chart.legend.valueLabels.template.disabled = true;
    this.chart.legend.position = "left";
    this.chart.legend.itemContainers.template.paddingBottom = 10;
    this.chart.legend.labels.template.truncate = false;
    this.chart.legend.scrollable = true;
    this.chart.legend.scrollbar.thumb.background.fill = color(CYAN);
    this.chart.legend.scrollbar.thumb.background.stroke = color(CYAN);

    const series = this.chart.series.push(new PieSeries());
    series.dataFields.value = valueField;
    series.dataFields.category = categoryField;
    series.labels.template.disabled = true;
    // series.slices.template.propertyFields.fill = "color";
    series.colors.list = CCS_ANALYSIS_COLORS.map((chartColor: string) => color(chartColor));
    series.slices.template.tooltipText = "{category}: {value}%";
    series.slices.template.adapter.add("tooltipText", (value: any, target: any) => {
      let text = value;
      const dataValue = target?.tooltipDataItem?.dataContext as { [index: string]: string | number };
      text += `\n ${dataValue?.entry_page_mapped} visits: ${dataValue?.visits?.toLocaleString()}`;
      return text;
    });

    if (series.tooltip) {
      series.tooltip.autoTextColor = false;
      series.tooltip.label.fill = color(WHITE);
      series.tooltip.label.fontSize = 15;
    }
  }

  render() {
    return (
      <>
        <div className={"chartWrapper"}>
          <div id={this.props.chartId} data-test-id={this.props.chartId} className={"graph"} />
        </div>
      </>
    );
  }
}

export default JourneyExcellenceDonutChart;
